'use client';
import { AnimatePresence, motion } from 'motion/react';
import React from 'react';

import { Tech } from '@/payload-types';
import { cn } from '@/utils/cn';

import { TechCard } from '../TechCard';
import styles from './TechsList.module.scss';

type Props = {
  cards: Tech[];
  title?: string;
  trackingCTA?: string;
};

const cardVariants = (y: number) => ({
  hidden: {
    y,
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
  },
});

export const TechsList: React.FC<Props> = ({ cards, title, trackingCTA }) => {
  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <div className={cn('container', styles.wrapper)}>
      {title && (
        <div className={styles.heading}>
          {title} <div className={styles.divider} />
        </div>
      )}
      <div className={styles.list}>
        <AnimatePresence>
          {cards.map((card, index) => {
            const y = index % 4 === 1 ? 96 : index % 4 === 3 ? 48 : 0;
            const cardVariant = cardVariants(y);

            return (
              <motion.div
                key={card.id}
                initial='hidden'
                whileInView='visible'
                viewport={{ once: true }}
                variants={cardVariant}
                transition={{
                  ease: [0.625, 0.05, 0, 1],
                  duration: 0.6,
                }}
                style={{ willChange: 'opacity, transform' }}
                layout
              >
                <TechCard
                  className={styles.card}
                  tracking={{
                    type: 'Technology list',
                    headline: trackingCTA || title || '',
                    cta: card.title,
                  }}
                  {...card}
                />
              </motion.div>
            );
          })}
        </AnimatePresence>
      </div>
    </div>
  );
};
